/**
 * @desc 采购比例分配审批通过
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierPurchaseRatioApplyRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/confirmPurchaseRatio`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
